/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {FloatElement, Header, SubText, Body, MainText, UpperHeader} from './styles';
import {Person} from '../../../assets/icons/icons';

export default props => {
  return (
    <FloatElement>
      <Header>
        <UpperHeader>
          <MainText>{props.title}</MainText>
          <Person height="14px" width="12.6px" />
          <span> {props.numberOfPlayers}</span>
        </UpperHeader>
        <SubText>{props.subTitle}</SubText>
      </Header>
      <Body>{props.children}</Body>
    </FloatElement>
  );
};
